var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 157,
    viewBox: "0 0 218 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2088 62.1719H105.244L126.762 99.4471L105.244 136.713H62.2088L40.6815 99.4471L62.2088 62.1719Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.674 14.5156H142.876L156.477 38.0764L142.876 61.631H115.674L102.067 38.0764L115.674 14.5156Z",
    fill: "#E2F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_394370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4177 93.4357C71.3728 93.4357 70.2826 93.1177 69.374 92.3908C67.1934 90.71 66.7845 87.5754 68.4654 85.3948L69.6011 83.8957C66.8754 81.8514 63.1502 78.9439 59.5159 75.7639C48.3405 65.9968 44.3428 59.0916 46.4779 53.413C50.0668 44.0092 64.922 35.6049 66.6028 34.6964C67.8748 34.0149 69.3285 33.8786 70.6914 34.3784L78.3689 37.1041C80.9583 38.0127 82.3212 40.8747 81.4126 43.5095C80.504 46.099 77.642 47.4618 75.0071 46.5533L69.5557 44.5998C64.3314 47.7798 57.6988 52.8678 56.0179 56.6839C56.2451 57.5016 57.7897 61.2267 67.3751 69.4039C73.3717 74.4919 79.4592 78.7168 79.5046 78.7622C80.6403 79.5345 81.3672 80.7611 81.5943 82.0785C81.8214 83.4414 81.458 84.8042 80.6403 85.8945L76.37 91.4823C75.3706 92.7543 73.9168 93.4357 72.4177 93.4357Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.879 93.4357C140.924 93.4357 142.015 93.1177 142.923 92.3908C145.104 90.71 145.513 87.5754 143.832 85.3948L142.696 83.8957C145.422 81.8514 149.147 78.9439 152.781 75.7639C163.911 65.9968 167.954 59.0916 165.774 53.413C162.23 44.0092 147.33 35.6049 145.649 34.6964C144.377 34.0149 142.923 33.8786 141.56 34.3784L133.883 37.1041C131.293 38.0127 129.931 40.8747 130.839 43.5095C131.748 46.099 134.61 47.4618 137.245 46.5533L142.696 44.5998C147.92 47.7798 154.553 52.8678 156.234 56.6839C156.007 57.5016 154.462 61.2267 144.877 69.4039C138.835 74.5828 132.747 78.8076 132.656 78.8531C131.521 79.6254 130.794 80.8519 130.567 82.1694C130.339 83.5322 130.703 84.8951 131.521 85.9854L135.791 91.5731C136.881 92.7543 138.38 93.4357 139.879 93.4357Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.884 97.3185C119.867 97.3303 119.85 97.3425 119.834 97.355L120.708 98.488C119.834 97.355 119.833 97.3555 119.833 97.3561L119.831 97.3573L119.828 97.3601L119.819 97.3672L119.793 97.3875C119.773 97.4038 119.746 97.4255 119.713 97.4528C119.648 97.5073 119.559 97.5838 119.45 97.6827C119.233 97.8805 118.936 98.1682 118.59 98.5483C117.9 99.308 117.015 100.441 116.194 101.967C114.543 105.035 113.179 109.638 114.114 115.872C114.184 116.336 114.476 116.736 114.897 116.943L128.196 123.497H106.262H84.3273L97.6266 116.943C98.044 116.738 98.3354 116.342 98.4076 115.882C99.3904 109.626 98.052 105.02 96.41 101.952C95.5938 100.428 94.7106 99.2976 94.0209 98.5403C93.6759 98.1615 93.3784 97.875 93.1606 97.6781C93.0516 97.5796 92.9624 97.5033 92.8969 97.449C92.8641 97.4219 92.8373 97.4002 92.8169 97.384L92.7911 97.3636L92.7819 97.3565L92.7783 97.3537L92.7767 97.3525C92.776 97.3519 92.7753 97.3514 91.9061 98.488L92.7753 97.3514C92.7606 97.3402 92.7456 97.3292 92.7305 97.3185L89.9687 95.3717C89.9671 95.3706 89.9655 95.3695 89.964 95.3684C85.3736 92.0758 81.8342 87.5365 79.8938 82.2326L79.8911 82.2255C77.9069 76.8902 76.8917 71.1989 76.8917 65.4613V37.2046C76.8917 35.9876 77.8783 35.0011 79.0952 35.0011H106.307H133.519C134.736 35.0011 135.722 35.9876 135.722 37.2046V65.4613C135.722 71.1522 134.708 76.8449 132.722 82.2291L132.72 82.2326C130.778 87.5425 127.281 92.0786 122.653 95.3666C122.652 95.3671 122.651 95.3676 122.651 95.3681L119.884 97.3185Z",
    fill: "#E2F2FF",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.035 35.3984H118.915V60.4454C118.915 65.8849 119.358 66.1379 117.776 76.1946C116.195 86.2514 112.21 90.0464 108.922 95.3594C106.29 99.6097 107.825 111.551 108.922 116.991C108.163 102.001 111.831 98.6484 117.776 92.1336C123.722 85.6189 125.936 80.6854 127.58 76.1946C128.896 72.602 129.098 67.7402 129.035 65.7584V35.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.309 124.969H78.2344V144.114C78.2344 145.86 80.1878 147.251 82.641 147.251H106.309H129.978C132.431 147.251 134.384 145.86 134.384 144.114V124.969H106.309Z",
    fill: "#78A1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.884 97.3185C119.867 97.3303 119.85 97.3425 119.834 97.355L120.708 98.488C119.834 97.355 119.833 97.3555 119.833 97.3561L119.831 97.3573L119.828 97.3601L119.819 97.3672L119.793 97.3875C119.773 97.4038 119.746 97.4255 119.713 97.4528C119.648 97.5073 119.559 97.5838 119.45 97.6827C119.233 97.8805 118.936 98.1682 118.59 98.5483C117.9 99.308 117.015 100.441 116.194 101.967C114.543 105.035 113.179 109.638 114.114 115.872C114.184 116.336 114.476 116.736 114.897 116.943L128.196 123.497H106.262H84.3273L97.6266 116.943C98.044 116.738 98.3354 116.342 98.4076 115.882C99.3904 109.626 98.052 105.02 96.41 101.952C95.5938 100.428 94.7106 99.2976 94.0209 98.5403C93.6759 98.1615 93.3784 97.875 93.1606 97.6781C93.0516 97.5796 92.9624 97.5033 92.8969 97.449C92.8641 97.4219 92.8373 97.4002 92.8169 97.384L92.7911 97.3636L92.7819 97.3565L92.7783 97.3537L92.7767 97.3525C92.776 97.3519 92.7753 97.3514 91.9061 98.488L92.7753 97.3514C92.7606 97.3402 92.7456 97.3292 92.7305 97.3185L89.9687 95.3717C89.9671 95.3706 89.9655 95.3695 89.964 95.3684C85.3736 92.0758 81.8342 87.5365 79.8938 82.2326L79.8911 82.2255C77.9069 76.8902 76.8917 71.1989 76.8917 65.4613V37.2046C76.8917 35.9876 77.8783 35.0011 79.0952 35.0011H106.307H133.519C134.736 35.0011 135.722 35.9876 135.722 37.2046V65.4613C135.722 71.1522 134.708 76.8449 132.722 82.2291L132.72 82.2326C130.778 87.5425 127.281 92.0786 122.653 95.3666C122.652 95.3671 122.651 95.3676 122.651 95.3681L119.884 97.3185Z",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.594 9.59375V19.4462",
    stroke: "#C1A2E7",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.594 25.9844V35.8311",
    stroke: "#C1A2E7",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.718 22.4141H172.871",
    stroke: "#C1A2E7",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.323 22.4141H156.477",
    stroke: "#C1A2E7",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.461 77.7656V81.7104",
    stroke: "#E4D6F5",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.461 84.3281V88.2706",
    stroke: "#E4D6F5",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.712 82.8984H178.77",
    stroke: "#E4D6F5",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.15 82.8984H172.207",
    stroke: "#E4D6F5",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4727 67.2969L37.7267 81.5509",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7267 67.2969L23.4727 81.5509",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6016 64.3438V84.5018",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.679 74.4219H20.5234",
    stroke: "#9DBDD1",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4557 23.3081L49.0297 25.6165L40.4557 27.9249C34.3937 29.5574 29.6588 34.2922 28.0263 40.3543L25.7179 48.9283L23.4095 40.3543C21.7769 34.2922 17.0421 29.5574 10.9841 27.9249L2.41016 25.6165L10.9841 23.3081C17.0462 21.6755 21.781 16.9407 23.4136 10.8787L25.722 2.30469L28.0303 10.8787C29.6588 16.9407 34.3937 21.6755 40.4557 23.3081Z",
    fill: "#E4D6F5",
    stroke: "#C1A2E7",
    strokeWidth: 2.86156,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.242 49.4887L213.762 50.7053C214.814 50.9886 214.814 52.4816 213.762 52.7648L209.242 53.9814C203.347 55.5675 198.738 60.1759 197.146 66.0777L195.929 70.5975C195.646 71.6499 194.153 71.6499 193.869 70.5975L192.653 66.0777C191.067 60.1827 186.458 55.5743 180.557 53.9814L176.037 52.7648C174.984 52.4816 174.984 50.9886 176.037 50.7053L180.557 49.4887C186.451 47.9027 191.06 43.2942 192.653 37.3924L193.869 32.8726C194.153 31.8203 195.646 31.8203 195.929 32.8726L197.146 37.3924C198.738 43.2942 203.347 47.9027 209.242 49.4887Z",
    fill: "#9DBDD1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6055 42.7812V63.4923",
    stroke: "white",
    strokeWidth: 6.07199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6055 72.6094V72.8446",
    stroke: "white",
    strokeWidth: 6.07199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_394370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.432,
    height: 125.838,
    fill: "white",
    transform: "translate(45.9336 30.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseComplete);
export default __webpack_public_path__ + "static/media/courseComplete.7326ba1accd4ba45fc87bf089a42af7b.svg";
export { ForwardRef as ReactComponent };